module.exports = __webpack_public_path__ + "static/media/category3.50f451e9.png";